export class MaxusDealer {
    name;
    street;
    houseNumber;
    postalCode;
    city;
    phoneNumber;
    phoneNumberLink;
    id;
    slug;
    services;
    websiteURL;
    dealerContainer;
    dealerBox;
    dealerOpeningHoursTitle;
    contentLink;
    detailLink;
    contactFormButton;
    salesLocation;
    serviceLocation;
    pillBox;
    constructor(name, street, houseNumber, postalCode, city, phoneNumber, phoneNumberLink, id, slug, services, websiteURL) {
        this.name = name;
        this.street = street;
        this.houseNumber = houseNumber;
        this.postalCode = postalCode;
        this.city = city;
        this.phoneNumber = phoneNumber;
        this.phoneNumberLink = phoneNumberLink;
        this.id = id;
        this.slug = slug;
        this.services = services;
        this.websiteURL = websiteURL;
        this.dealerContainer = document.querySelector('.js-establishment');
        if (!this.dealerContainer)
            return;
        this.dealerBox = document.createElement('div');
        this.dealerBox.setAttribute('class', 'col-xl-4 col-md-6 my-4');
        this.contentLink = this.dealerContainer.dataset.contactformlink;
        this.detailLink = this.dealerContainer.dataset.establishmentdetaillink;
        if (this.contentLink) {
            this.contactFormButton = document.createElement('a');
            this.contactFormButton.setAttribute('class', 'button mt-4');
            this.contactFormButton.setAttribute('href', `${this.contentLink}?establishmentid=${this.id}`);
            this.contactFormButton.innerHTML = 'Neem contact op';
        }
        services.forEach((item) => {
            if (item.includes('Occasions') || item.includes("Nieuwe auto's")) {
                this.salesLocation = true;
            }
            if (item.includes('Service') || item.includes('Schadeherstel')) {
                this.serviceLocation = true;
            }
        });
    }
    createPillBox() {
        const salePill = this.salesLocation ? '<div class="pill">Verkoop</div>' : '';
        const servicePill = this.serviceLocation ? '<div class="pill">Service</div>' : '';
        return this.salesLocation || this.serviceLocation
            ? `<div class="pillbox">${salePill}${servicePill}</div>`
            : '';
    }
    renderListView() {
        this.pillBox = this.createPillBox();
        const phoneLink = this.phoneNumberLink
            ? `
            <a href="tel:${this.phoneNumberLink}" class="dealer-box__phone-link" alt="phonenumber ${this.name}"  title="phonenumber ${this.name}">
                ${this.phoneNumber}
            </a>`
            : '';
        const website = this.websiteURL
            ? `<a href="${this.websiteURL}" class="dealer-detail__website-link" target="_blank" alt="website ${this.name}"  title="website ${this.name}">
                    Bekijk website
                </a>`
            : '';
        this.dealerBox.innerHTML = `
        <div class="dealer-box">
            <h3 class="dealer-box__title h6">${this.name}</h3>
            ${this.pillBox}
            <div class="dealer-box__address">
                <div>
                    ${this.street}
                    ${this.houseNumber}
                </div>
                <div>
                    ${this.postalCode}
                    ${this.city}
                </div>
            </div>
            ${phoneLink}
            ${website}
        </div>
        <a href="${this.detailLink}${this.slug}" class="button mt-4">Meer informatie</a>
        `;
        return this.dealerBox;
    }
}
export class MaxusDealerDetail extends MaxusDealer {
    name;
    street;
    houseNumber;
    postalCode;
    city;
    phoneNumber;
    phoneNumberLink;
    id;
    slug;
    services;
    websiteURL;
    image;
    email;
    openingHours;
    whatsappNumber;
    dealerDetail;
    dealerOpeningHours;
    dealerOpeningHoursBox;
    dealerOpeningHoursList;
    dealerOpeningHoursitem;
    entry;
    constructor(name, street, houseNumber, postalCode, city, phoneNumber, phoneNumberLink, id, slug, services, websiteURL, image, email, openingHours, whatsappNumber) {
        super(name, street, houseNumber, postalCode, city, phoneNumber, phoneNumberLink, id, slug, services, websiteURL);
        this.name = name;
        this.street = street;
        this.houseNumber = houseNumber;
        this.postalCode = postalCode;
        this.city = city;
        this.phoneNumber = phoneNumber;
        this.phoneNumberLink = phoneNumberLink;
        this.id = id;
        this.slug = slug;
        this.services = services;
        this.websiteURL = websiteURL;
        this.image = image;
        this.email = email;
        this.openingHours = openingHours;
        this.whatsappNumber = whatsappNumber;
        this.dealerDetail = document.querySelector('.dealer-detail__box');
        if (!this.dealerDetail)
            return;
        this.dealerOpeningHours = document.createElement('div');
        this.dealerOpeningHours.setAttribute('class', 'row justify-content-between');
        Object.values(this.openingHours).forEach((val, i) => {
            const titleName = {
                showroom: 'showroom',
                workplace: 'werkplaats',
            };
            let openingHoursTitle = `Openingstijden ${titleName[Object.getOwnPropertyNames(this.openingHours)[i]]}`;
            let entries = Object.entries(val);
            let className = '';
            const dutchWeekdays = {
                monday: 'Maandag',
                tuesday: 'Dinsdag',
                wednesday: 'Woensdag',
                thursday: 'Donderdag',
                friday: 'Vrijdag',
                saturday: 'Zaterdag',
                sunday: 'Zondag',
                comments: 'Opmerking',
            };
            let info = entries.map(([key, val] = this.entry) => {
                if (key == 'comments') {
                    className = ' openingshour-info-comment';
                }
                if (val) {
                    return `<div class="openingshour-info-left${className}">${dutchWeekdays[key]}</div> <div class="openingshour-info-right">${val}</div>`;
                }
                else {
                    return null;
                }
            });
            this.dealerOpeningHoursList = document.createElement('ul');
            this.dealerOpeningHoursList.setAttribute('class', 'openingshour-list');
            info.forEach((item) => {
                if (item == null)
                    return;
                this.dealerOpeningHoursitem = document.createElement('li');
                this.dealerOpeningHoursitem.setAttribute('class', 'openingshour-item');
                this.dealerOpeningHoursitem.innerHTML = item;
                this.dealerOpeningHoursList.append(this.dealerOpeningHoursitem);
            });
            if (this.dealerOpeningHoursList.childElementCount > 0) {
                this.dealerOpeningHoursBox = document.createElement('div');
                this.dealerOpeningHoursBox.setAttribute('class', 'col-xl-5 col-lg-6 col-12 mt-4');
                this.dealerOpeningHoursTitle = document.createElement('h3');
                this.dealerOpeningHoursTitle.innerHTML = openingHoursTitle;
                this.dealerOpeningHoursBox.append(this.dealerOpeningHoursTitle);
                this.dealerOpeningHoursBox.append(this.dealerOpeningHoursList);
                this.dealerOpeningHours.append(this.dealerOpeningHoursBox);
            }
        });
        services.forEach((item) => {
            if (item.includes('Occasions') || item.includes("Nieuwe auto's")) {
                this.salesLocation = true;
            }
            if (item.includes('Service') || item.includes('Schadeherstel')) {
                this.serviceLocation = true;
            }
        });
    }
    renderDetailView() {
        this.pillBox = this.createPillBox();
        const phoneLink = this.phoneNumberLink
            ? `
            <div class="dealer-detail__contact">
                <span>Telefoon</span>
                <a href="tel:${this.phoneNumberLink}" class="dealer-detail__phone-link" alt="phonenumber ${this.name}"  title="phonenumber ${this.name}">
                    ${this.phoneNumber}
                </a>
            </div>`
            : '';
        const website = this.websiteURL
            ? `
            <div class="dealer-detail__contact">
                <span>Website</span>
                <a href="${this.websiteURL}" class="dealer-detail__website-link" target="_blank" alt="website ${this.name}"  title="website ${this.name}">
                    ${this.websiteURL}
                </a>
            </div>`
            : '';
        const whatsappLink = this.whatsappNumber
            ? `
                <div class="dealer-detail__contact">
                    <span>Whatsapp</span>
                    <a href="https://wa.me/${this.whatsappNumber}" class="dealer-detail__mail-link" alt="whatsappnumber ${this.name}"  title="whatsappnumber ${this.name}">
                        ${this.whatsappNumber}
                    </a>
                </div>`
            : '';
        const mailLink = this.email
            ? `
            <div class="dealer-detail__contact">
                <span>Email</span>
                <a href="mailto:${this.email}" class="dealer-detail__mail-link" alt="mailadress ${this.name}"  title="mailadress ${this.name}">
                   ${this.email}
                </a>
            </div>`
            : '';
        const imageBox = this.image
            ? `<div class="col-lg-6 col-12">
                    <div class="dealer-detail__image">
                        <img src="${this.image}" alt="${this.name}-image" title="${this.name}-image">
                    </div>
                </div>`
            : '';
        this.dealerDetail.innerHTML = `
        <div class="row justify-content-between align-items-center">
            ${imageBox}
            <div class="col-xl-5 col-lg-6 col-12">
                <div class="dealer-detail__content">
                    <h1>${this.name}</h1>
                    ${this.pillBox}
                    <div class="dealer-detail__address">
                        <div>
                            ${this.street}
                            ${this.houseNumber}
                        </div>
                        <div>
                            ${this.postalCode}
                            ${this.city}
                        </div>
                    </div>
                    ${phoneLink}
                    ${website}
                    ${whatsappLink}
                    ${mailLink}
                </div>
            </div>
        </div>
        `;
        this.dealerDetail.append(this.dealerOpeningHours);
        return this.dealerDetail;
    }
}
